export const upPartnerRules = {
  upPartnerName: [{ required: true, message: '请选择上游合作方' }],
  upPartnerContactPerson: [{ required: true, message: '请输入上游合作方联系人' }],
  upPartnerContactPhone: [{ required: true, message: '请输入上游合作方联系电话' }],
  upPartnerNature: [{ required: true, message: '请输入上游合作方企业性质' }],
  upPartnerPayMethod: [
    { required: true, message: '请选择上游合作方付款方式', trigger: ['change'] },
  ],
  upPartnerReconciliationRules: [{ required: true, message: '请选择上游合作方对账规则' }],
};

export const downPartnerRules = {
  downPartnerName: [{ required: true, message: '请选择下游合作方' }],
  downPartnerContactPerson: [{ required: true, message: '请输入下游合作方联系人' }],
  downPartnerContactPhone: [{ required: true, message: '请输入下游合作方联系电话' }],
  downPartnerPayMethod: [
    {
      required: true,
      message: '请选择下游合作方结算方式',
      trigger: ['change'],
    },
  ],
  downPartnerReconciliationRules: [{ required: true, message: '请选择下游合作方对账规则' }],
};
